var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-theme',[_c('div',{staticClass:"container mt-5"},[_c('div',{staticClass:"column is-12 is-centered"},[_c('b-message',{attrs:{"type":"is-success","has-icon":""}},[_vm._v(" Seja bem-vindo e aproveite seu tempo."),_c('br'),_vm._v(" Aguarde a inicialização do equipamento... ")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }